<template>
    <div>
        <el-row style="margin-top:20px">
            <el-col>
                <el-table :data="tableData" border stripe>
                    <el-table-column type="index" width="50" label="序号"></el-table-column>
                    <el-table-column prop="NAME" label="产品名称"></el-table-column>
                    <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
                    <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
                    <el-table-column prop="TC_NAME" label="团餐公司"></el-table-column>
                    <el-table-column prop="PROJECT_NAME" label="门店"></el-table-column>
                    <el-table-column prop="DK_NAME" label="档口"></el-table-column>
                    <el-table-column prop="SEND_DAY" label="送货日期"></el-table-column>
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" icon="el-icon-close" @click="deleteSku(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import { queryPriceAudit, deletedSku } from '@/assets/api/sellOrder';
import { frontEndFun } from '@/assets/api/frontFun';

export default {
  data() {
    return {
      PAGE_ID: '10049', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 1004901: 0 }, // 功能ID 一旦规定不要轻易改动
      tableData: [],
    };
  },
  created() {
    this.queryBeforeFun();
    this.queryData();
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 删除
    deleteSku(row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          ORDER_DETAIL_ID: row.DETAIL_ID,
        };
        deletedSku(params)
          .then((result) => {
            this.$message.show({ text: '删除成功', type: 'success' });
            this.queryData();
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      }).catch(() => {
        this.$message.show({ text: '操作取消', type: 'info' });
      });
    },
    queryData() {
      queryPriceAudit()
        .then((result) => {
          if (result.length !== 0) {
            this.tableData = result.map((item) => Object.assign(item, { PRODUCT_CODE: item.PRODUCT_CODE.toString() }));
          } else {
            this.tableData = [];
            this.$message.show({ text: '暂无数据', type: 'success' });
          }
        });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/sellOrderManage/priceAudit.vue